import React from 'react';
import { Flex, Typography } from 'antd';
import { Button } from '@bettercomp/ui-components';
import { SurveySeason } from 'types';

import { SurveySeasonBadge } from './SurveySeasonBadge';
import cn from './styles.module.scss';

type MinimizedBannerProps = {
  surveySeason?: SurveySeason;
  onAction: () => void;
  onShow: () => void;
};

/**
 * Shown on Settings > Plans in place of the full banner once banners are hidden —
 * the confirm modal promises they can be turned back on from here, so this stays
 * the one remaining entry point for both continuing the plan (or starting one) and
 * re-showing the full banners.
 */
export function MinimizedBanner({ surveySeason, onAction, onShow }: MinimizedBannerProps) {
  return (
    <Flex align="center" gap={16} className={cn.minimizedContent}>
      <Flex vertical gap={4} className={cn.body}>
        <SurveySeasonBadge label="Survey Refresh Workflow" />
        <Typography.Title level={5} className={cn.title}>
          {surveySeason ? surveySeason.plan?.name : 'Get started on your next plan'}
        </Typography.Title>
        <Typography.Paragraph className={cn.minimizedDescription}>
          {surveySeason
            ? 'Pick up where you left off and roll into the new season.'
            : 'Kick off your next plan whenever you\'re ready.'}
        </Typography.Paragraph>
      </Flex>
      <Flex align="center" gap={16} className={cn.action}>
        <Button
          type="link"
          className={cn.link}
          onClick={onShow}
          data-testid="surveySeasonShowBannerButton"
        >
          Show banner
        </Button>
        <Button
          type="primary"
          onClick={onAction}
          data-testid="surveySeasonMinimizedActionButton"
        >
          {surveySeason ? 'Continue' : 'Get Started'}
        </Button>
      </Flex>
    </Flex>
  );
}
